export default  [
        {
            name: "CHRISTY KINNEY",
            position: "Principal",
            image: require('../../public/assets/images/team/christy.jpg'),
            fact: "I was one of the very first employees at EMP (experience music project)!"
        },
        {
            name: "DAVID BERRY",
            position: "Operations Manager, Sr. Project Manager",
            image: require('../../public/assets/images/team/Dave.jpg'),
            fact: "love Bass fishing but don’t get out to do it enough."
        },
        {
            name: "JACKIE LEE",
            position: "Office Manager",
            image: require('../../public/assets/images/team/unnamed.jpg'),
            fact: null
        },
        {
            name: "JOEL NORBERG",
            position: "Engineer, Project Manager",
            image: require('../../public/assets/images/team/Joel.jpg'),
            fact: `I’m a boat fanatic working on my 1969 36′ wooden Chris craft….. Or riding my Moto Guzzi motorcycle on short and long trips.`
        },
        {
            name: "CHAD THOMAS",
            position: "Lead Technician",
            image: require('../../public/assets/images/team/Chad.jpg'),
            fact: "I love the outdoors and I volunteer with the King County Search and Rescue."
        },
        {
            name: "MIKE JOHNSON",
            position: "AV Technician",
            image: require('../../public/assets/images/team/Mike.jpg'),
            fact: "I like mountain biking and camping with my family."
        },
        {
            name: "DAVID DARNELL",
            position: "AV Technician",
            image: require('../../public/assets/images/team/David.jpg'),
            fact: "I am a diver and a welder."
        },
        {
            name: "DANIEL JELINEK",
            position: "AV Technician",
            image: require('../../public/assets/images/team/Dan.jpg'),
            fact: " A prolific artist."
        },
        {
            name: "MATT BENNETT",
            position: "AV Technician",
            image: require('../../public/assets/images/team/Matt.jpg'),
            fact: "I’m a licensed A+P Mechanic"
        },
        {
            name: "JAMES MOYER",
            position: "AV Technician",
            image: require('../../public/assets/images/team/unnamed.jpg'),
            fact: null
        },
        {
            name: "CALE MABBOTT",
            position: "AV Technician",
            image: require('../../public/assets/images/team/unnamed.jpg'),
            fact: null
        },
        

    ]